"use client";

import { OfferInfoNewOrUpdated } from "@/components/hlidaci-pes/OfferInfoNewOrUpdated";
import { EstateOfferImage } from "@/components/hlidaci-pes/EstateOfferImage";
import { formatCzDate } from "@/lib/date";
import { formatCzkPrice } from "@/lib/price";
import { EstateCardProp } from "@/types";
import { Panel } from "@/components/ui/Panel";
import Link from "next/link";
import { ResultActionIcons } from "@/components/hlidaci-pes/watchdog-page/ResultActionIcons";
import { SoftiqIndexDialog } from "@/components/hlidaci-pes/SoftiqIndexDialog";
import { useState } from "react";

const EstateCardList = ({
  estateOffer,
  editSpecificResult,
  imageHeightClass = "h-64",
}: EstateCardProp) => {
  const [isIndexDialogOpen, setIsIndexDialogOpen] = useState(false);
    return (
        <div className="relative w-full h-full ">
            <Link
                href={estateOffer.offerUrl}
                target="_blank"
                className="block w-full h-full"
            >
                <Panel className="flex h-full w-full flex-col overflow-hidden p-0">
                    <div className="relative min-h-14 w-full">
                        <OfferInfoNewOrUpdated offer={estateOffer}/>
                        <div className="absolute right-3 top-3 z-10">
                            <ResultActionIcons
                                estateOffer={estateOffer}
                                editSpecificResult={editSpecificResult}
                                isMainPage={false}
                            />

                        </div>

                    </div>

                    <div className="grid grid-cols-2 gap-2 mx-2">
                        {/* TITLE + ADDRESS */}
                        <div className="col-span-2 rounded-lg bg-[#f4f7f5] px-2.5 py-2.5">
    <span className="block text-[0.62rem] text-[#7DA596] mb-1 whitespace-nowrap">
      Nabídka
    </span>
                            <span className="block text-[0.82rem] font-semibold text-[#1B4242] truncate">
    {estateOffer.header
        ? estateOffer.header.charAt(0).toUpperCase() + estateOffer.header.slice(1)
        : ""}
</span>
                            <span className="block text-xs text-[#1B4242] mt-1 truncate">
      {estateOffer.address}
    </span>
                        </div>

                        {/* TOTAL PRICE */}
                        <div className="rounded-lg bg-[#f4f7f5] px-2.5 py-2.5">
    <span className="block text-[0.62rem] text-[#7DA596] mb-1 whitespace-nowrap">
      Cena
    </span>

                            <span className="block text-[0.97rem] font-bold text-[#1B4242] whitespace-nowrap">
      {formatCzkPrice(estateOffer.price)}
    </span>
                        </div>

                        {/* PRICE / M² */}
                        <div className="rounded-lg bg-[#f4f7f5] px-2.5 py-2.5">
    <span className="block text-[0.62rem] text-[#7DA596] mb-1 whitespace-nowrap">
      Cena za m²
    </span>

                            <span className="block text-[0.82rem] font-semibold text-[#1B4242] whitespace-nowrap">
      {formatCzkPrice(estateOffer.pricePerSquareMeter)}
    </span>
                        </div>

                        {/* AREA */}
                        <div className="rounded-lg bg-[#f4f7f5] px-2.5 py-2.5">
    <span className="block text-[0.62rem] text-[#7DA596] mb-1 whitespace-nowrap">
      Plocha
    </span>

                            <span className="block text-[0.82rem] font-semibold text-[#1B4242] whitespace-nowrap">
      {estateOffer.squareMeter} m²
    </span>
                        </div>

                        {estateOffer.softiqIndex != null && (
                        <div
                          className="rounded-lg bg-[#f4f7f5] px-2.5 py-2.5 flex flex-col items-center cursor-pointer hover:bg-[#e8ede9] transition-colors"
                          onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsIndexDialogOpen(true);
                          }}
                        >
                        <div className="mb-1 text-[0.55rem] font-semibold tracking-[1.5px] uppercase text-[#7DA596]">
                            SOFTIQ INDEX
                        </div>

                        <span
                            className="block text-[0.9rem] font-bold leading-none"
                            style={{
                                color:
                                    Number(estateOffer.softiqIndex) >= 1.5
                                        ? "#4F8067"
                                        : Number(estateOffer.softiqIndex) >= -1.5
                                            ? "#697875"
                                            : "#B64F4F",
                            }}
                        >
        {Math.round(Number(estateOffer.softiqIndex))}
    </span>

                        <div className="relative mt-1.5 w-[70px]">
                            {/* Scale */}
                            <div
                                className="relative h-[4px] w-full rounded-full"
                                style={{
                                    background:
                                        "linear-gradient(to right, #C65B5B 0%, #E3A17E 25%, #D7DEDA 50%, #8BB49F 75%, #4F8067 100%)",
                                }}
                            >
                                {/* Zero marker */}
                                <div className="absolute left-1/2 -top-px h-[6px] w-px bg-white" />

                                {/* Index marker */}
                                <div
                                    className="absolute -top-0.5 h-2 w-2 -translate-x-1/2 rounded-full border-[1.5px] bg-white shadow-[0_1px_3px_rgba(27,66,66,0.15)]"
                                    style={{
                                        left: `${Math.max(
                                            0,
                                            Math.min(
                                                100,
                                                ((Number(estateOffer.softiqIndex) + 10) / 20) * 100
                                            )
                                        )}%`,
                                        borderColor:
                                            Number(estateOffer.softiqIndex) >= 1.5
                                                ? "#4F8067"
                                                : Number(estateOffer.softiqIndex) >= -1.5
                                                    ? "#697875"
                                                    : "#C65B5B",
                                    }}
                                />
                            </div>

                            {/* Scale labels */}
                            <div className="mt-1 flex w-full justify-between text-[0.45rem] leading-none text-[#879590]">
                                <span>-10</span>
                                <span>0</span>
                                <span>+10</span>
                            </div>
                        </div>
                        </div>
                        )}
                        <span className="text-[0.6rem] font-medium text-black whitespace-nowrap">
    {formatCzDate(estateOffer.createdAt)}
  </span>
                    </div>

                    {/* Image Row - bottom */}
                    <div
                        className={`w-full ${imageHeightClass} relative flex-shrink-0 mt-auto`}
                    >
                        <EstateOfferImage
                            source={estateOffer.mainPicUrl}
                            origin={estateOffer.origin}
                            offerUrl={estateOffer.offerUrl}
                            alt={estateOffer.header}
                            sizes="100vw"
                        />

                    </div>
                </Panel>
            </Link>

            <SoftiqIndexDialog
                isOpen={isIndexDialogOpen}
                onClose={() => setIsIndexDialogOpen(false)}
            />
        </div>
    );
};
export default EstateCardList;
